import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useSmallUrlValueStyles() {
  return useMemo(
    () => mergeStyleSets({
      link: {
        display: `inline-block`,
        marginRight: `8px`
      }
    }),
    []
  );
}
